import { Component, OnInit, Input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-to-existing-group',
  templateUrl: './to-existing-group.component.html',
  styleUrls: ['./to-existing-group.component.scss']
})
export class ToExistingGroupComponent implements OnInit {
  @Input('form') form:FormGroup;
  toExistingGroup:FormControl;
  ngOnInit() {
    this.toExistingGroup = this.form.get('toExistingGroup') as FormControl; 
  }
}
